<template>
  <div class="event-con-wrap" data-scroll-element="true">
    <div
      class="mypooq-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-distance="500"
      :infinite-scroll-throttle-delay="200"
    >
      <EventContent
        v-for="(contentInfo, index) in EventContentList"
        :key="index"
        :content-info="contentInfo"
        :content-type="contentType"
      />
    </div>
  </div>
</template>
<script>
import EventContent from '@/components/lnb/event/EventContent'
import { infiniteScroll } from '@/common/directives'

export default {
  name: 'EventContentList',
  components: { EventContent },
  directives: {
    infiniteScroll
  },
  props: {
    EventContentList: {
      type: Array,
      default: null
    },
    contentType: {
      type: String, // movie | vod
      default: ''
    }
  },
  methods: {
    loadMore () {
      this.$emit('load-more')
    }
  }
}
</script>
